export const CHANGE_SUB_NAV_STATUS = 'CHANGE_SUB_NAV_STATUS';
export const ERROR_ALL = 'ERROR_ALL';
export const ERROR_NETWORK = 'ERROR_NETWORK';
export const HIDE_ERROR = 'HIDE_ERROR';
export const SET_APP_CONFIG = 'SET_APP_CONFIG';
export const SET_LOADING = 'SET_LOADING';
export const SET_ACTIVE_SECTION = 'SET_ACTIVE_SECTION';
